import type layoutZh from '../zh/layout';

const layout: typeof layoutZh = {
  profile: 'Trung tâm tài khoản',
  upgrade: 'Mua / Nâng cấp',
  buy_plan: 'Mua/Nâng cấp',
  buy_entitlement: 'Mua gói quyền lợi riêng',
  brand_product: 'Kết nối KOL',
  support: 'Hỗ trợ',
  user_menu: 'Menu người dùng',
  role_admin: 'Quản trị viên',
  menu_workbench: 'Bàn làm việc',
  menu_store: 'Ủy quyền cửa hàng',
  menu_talent: 'Quảng trường KOL',
  menu_creator: 'Quản lý KOL',
  menu_invitation: 'Lời mời',
  menu_dm: 'Tin nhắn',
  menu_email: 'Email',
  menu_script: 'Kịch bản',
  no_shop: 'Chưa có cửa hàng',
  shop_load_failed: 'Không tải được danh sách cửa hàng'
};

export default layout;
